import {Button, Checkbox, Group, Stack, Text} from '@mantine/core';
import React, {useState} from 'react';

import {AutofillCompatibleBioentityOption} from 'metadata/AutofillCompatibleBioentityOptions';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';
import {RunModalProps} from 'ui-library/runModal';

export interface AutofillAfterRegistrationModalProps extends RunModalProps<Array<FieldType>> {
  availableAutofillOptions: Array<AutofillCompatibleBioentityOption>;
}

export default function AutofillAfterRegistrationModal({
  availableAutofillOptions,
  close,
}: AutofillAfterRegistrationModalProps): JSX.Element {
  const [selectedFieldTypes, setSelectedFieldTypes] = useState<Array<FieldType>>(
    availableAutofillOptions.map((option) => option.fieldType)
  );

  return (
    <Stack spacing="md">
      <Text>Would you like to autofill the following fields on your newly registered sequences?</Text>
      {availableAutofillOptions.map((option) => {
        const isChecked = selectedFieldTypes.includes(option.fieldType);
        return (
          <Checkbox
            key={option.fieldType}
            label={option.name}
            checked={isChecked}
            onChange={(event) => {
              const shouldSelect = event.currentTarget.checked;
              setSelectedFieldTypes((prevSelectedFieldTypes) =>
                shouldSelect
                  ? prevSelectedFieldTypes.includes(option.fieldType)
                    ? prevSelectedFieldTypes
                    : [...prevSelectedFieldTypes, option.fieldType]
                  : prevSelectedFieldTypes.filter((fieldType) => fieldType !== option.fieldType)
              );
            }}
          />
        );
      })}
      <Group position="right">
        <Button variant="secondary" onClick={() => close()}>
          Skip
        </Button>
        <Button onClick={() => close(selectedFieldTypes)}>Autofill</Button>
      </Group>
    </Stack>
  );
}
